import clientes from '../../data/Clientesdata';

import { useIdioma } from '../../context/IdiomaContext';

import './Clientes.css';

function Clientes() {
  const { t } = useIdioma();

  return (
    <section className="clientes">
      <h2>
        {t('clientes.titulo')}
      </h2>

      <div className="clientes-container">
        {clientes.map((cliente) => (
          <div
            className="cliente"
            key={cliente.nombre}
          >
            <img
              src={cliente.logo}
              alt={`${t(
                'clientes.logoAlt'
              )} ${cliente.nombre}`}
            />

            <span>{cliente.nombre}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Clientes;